(function (Wishlist, $) {

  var $wishlistButton = $('.wishlist-btn');
  var $wishlistTile = $('.wishlist-tile-container');
  var $wishlistItemCount = $('.wishlist-item-count');
  var numProductTiles = $wishlistTile.length;
  var wishlist = localStorage.getItem('user_wishlist') || [];
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  }

  /*
   * Update button to show current state (gold for active)
   */   
  var animateWishlist = function (self) {
    var wasActive = $(self).hasClass('is-active');
    $(self).toggleClass('is-active');
    if (!wasActive) {
      // Force a reflow so the browser registers .w_act's display:block
      // before the animation class lands — otherwise Chrome skips the animation.
      void self.offsetWidth;
      $(self).addClass('just-saved');
      setTimeout(function () {
        $(self).removeClass('just-saved');
      }, 560);
    }
    if (wishlist.length > 0)
    {
      $('.swym-wishlist.site-nav__link').addClass('active');
    } else {
      $('.swym-wishlist.site-nav__link').removeClass('active');
    }
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */   


var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    
    // Try to find the form and select element inside the form, if present
    var $form = $(self).closest('form');
    var $selectElement = $form.find('select[name="id"]');
    var variantId = null;

    // Check if the required input (line item property) is filled
    var $nameInput = $form.find('#type-your-name-here');
    var nameValue = $nameInput.val();
    
    // Validate that the name input is filled if required
    if ($nameInput.length > 0 && !nameValue) {
        alert('Please fill out the required "Type Your Name Here" input to add this product to the wishlist.');
        animateWishlist(self); // Keep this if you have an animation for adding/removing items
        return;
    }

    // If the form and select element are found, get the selected variant ID
    if ($selectElement.length > 0) {
        var $selectedOption = $selectElement.find('option:selected');
        variantId = $selectedOption.val() || $selectedOption.attr('data-variant-id');
        
        // Fallback: Check for disabled options if no selected option is found
        if (!variantId) {
            $selectElement.find('option').each(function() {
                if ($(this).is(':disabled')) {
                    variantId = $(this).attr('data-variant-id');
                    return false; // Exit loop once found
                }
            });
        }
    }

    // Fallback: If no form or select element is present, get the variant ID from the button's data attribute
    if (!variantId) {
        variantId = $(self).attr('data-variant-id');
    }

    // If variant ID is still not found, exit the function
    if (!variantId) {
        console.error('Variant ID not found');
        return;
    }

    // Determine if the item should be added or removed based on the button's state
    var isRemove = $(self).hasClass('is-active');

    /* Remove from Wishlist */
    if (isRemove) {
        var removeIndex = wishlist.findIndex(function(item) {
            return item.productHandle === productHandle && item.variantId === variantId;
        });
        if (removeIndex > -1) {
            wishlist.splice(removeIndex, 1); // Remove the item
            localStorage.setItem('user_wishlist', JSON.stringify(wishlist)); // Update localStorage
        }
    }
    /* Add to Wishlist */
    else {
        // Prepare the wishlist item
        var wishlistItem = { productHandle: productHandle, variantId: variantId };
        if ($nameInput.length > 0) {
            wishlistItem.nameValue = nameValue; // Include the name value if present
        }
        
        // Push the item to the wishlist
        wishlist.push(wishlistItem);
        localStorage.setItem('user_wishlist', JSON.stringify(wishlist)); // Save to localStorage
    }

};

  

document.addEventListener('variant:change', function(evt) {
  var variant = evt.detail.variant;
  
  // Assuming you are using jQuery, select the target modal and check if it's active
  let $currentModel = $(evt.target).closest('.modal--is-active');
  
  // Get the product handle from the wishlist button
  var productHandle = $('.wishlist-btn').attr('data-product-handle'); // Assuming each product has a data-product-handle attribute
  
  // Find if the current variant is in the wishlist
  var wishlistItem = wishlist.findIndex(function(item) {
    return item.productHandle === productHandle && item.variantId == variant.id; // Use == for type coercion, or change to === if strict equality needed
  });
  
  // Function to toggle wishlist state
  var toggleWishlistState = function(isInWishlist) {
    if ($currentModel.length > 0) {
      // If there's an active modal, find the wishlist button inside it
      $currentModel.find('.wishlist-btn').toggleClass('is-active', isInWishlist);
    } else {
      // If no active modal, toggle the global wishlist button
      $('.wishlist-btn').toggleClass('is-active', isInWishlist);
    }
  };
  
  // Check if the item is in the wishlist and toggle the wishlist button state accordingly
  toggleWishlistState(wishlistItem >= 0);
});



    /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */   

var displayOnlyWishlistItems = function () {
  $wishlistTile.each(function () {
    var $wishlistItem = $(this);
    var productHandle = $wishlistItem.attr('data-product-handle');
    
    // Find the wishlist item with the matching product handle
    var wishlistItem = wishlist.find(function (item) {
      return item.productHandle === productHandle;
    });

    // If the product handle is not in the wishlist, remove the tile
    if (!wishlistItem) {
      $wishlistItem.remove();
      numProductTiles--;
    } else {
      // Find the variant in the select dropdown
      var $selectElement = $wishlistItem.find('select[name="id"]');
      
      // Use the variant id from the data-attribute
      var $option = $selectElement.find('option[data-variant-id="' + wishlistItem.variantId + '"]');

      if ($option.length) {
        // Set the selected variant
        $selectElement.val($option.val());

        // Update the ATC button's variant ID using the `data-variant-id` attribute
        $wishlistItem.find('.CustomaddtoCartbuttonJS').attr('data-add-to-cart-id', wishlistItem.variantId);

        // Update the product image
        var variantImage = $option.attr('variant-image');
        $wishlistItem.find('.grid-bg-image').css('background-image', 'url("' + variantImage + '")');

        var variantTitle = $option.text();
        $wishlistItem.find('.grid-product__title').append('<p class="variant_title">' + variantTitle + '</p>');

        // Check variant availability and update ATC button text
        if ($option.is(':disabled')) {
          $wishlistItem.find('.CustomaddtoCartbuttonJS').text('Sold Out').prop('disabled', true);
        } else {
          $wishlistItem.find('.CustomaddtoCartbuttonJS').text('move to bag').prop('disabled', false);
        }

        // Add a remove button or cross symbol
        if (!$wishlistItem.find('.remove-from-wishlist').length) {
          $wishlistItem.append('<button class="remove-from-wishlist" aria-label="Remove from wishlist">×</button>');
        }

        // Add event listener to the remove button
        $wishlistItem.find('.remove-from-wishlist').on('click', function () {
          var removeIndex = wishlist.findIndex(function (item) {
            return item.productHandle === productHandle && item.variantId === wishlistItem.variantId;
          });
          if (removeIndex > -1) {
            // Remove item from wishlist array and update localStorage
            wishlist.splice(removeIndex, 1);
            localStorage.setItem('user_wishlist', JSON.stringify(wishlist));

            // Remove the item from the DOM
            $wishlistItem.fadeOut(400, function () {
              $(this).remove();
            });
          }
        });
      } else {
        console.warn('Variant ID not found for product handle: ' + productHandle);
      }
    }
  });
};




  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
  var loadWishlist = function () {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      displayOnlyWishlistItems();
      $('.wishlist-loader').fadeOut(400, function () {
        $('.wishlist-grid').addClass('is_visible');
        $('.wishlist-hero').addClass('is_visible');
        // if (numProductTiles == 0) {
        //   $('.wishlist-grid--empty-list').addClass('is_visible');
        // } else {
        //   $('.wishlist-grid--empty-list').hide();
        // }
      });
    }
  };
  

  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
var activateItemsInWishlist = function () {
  $wishlistButton.each(function () {
    var $wishlistItem = $(this);
    var productHandle = $wishlistItem.attr('data-product-handle');
    var variantId = $wishlistItem.closest('form').find('select[name="id"].product-single__variants').val();

    if (!variantId) {
      variantId = $wishlistItem.attr('data-variant-id');
    }

    var wishlistItem = wishlist.findIndex(function (item) {
      return item.productHandle === productHandle && item.variantId == variantId; // Use == for type coercion
    });

    if (wishlistItem >= 0) {
      $wishlistItem.addClass('is-active');
    } else {
      $wishlistItem.removeClass('is-active'); // Optionally remove 'is-active' if not in wishlist
    }
  });
};

  


  
document.addEventListener('quickview:loaded', function(evt) {
  // Get the wishlist button inside the quick view popup
  var $wishlistButton = $(evt.target).find('.wishlist-btn');

  // Loop through each wishlist button
  $wishlistButton.each(function () {
    var $wishlistItem = $(this);
    var productHandle = $wishlistItem.attr('data-product-handle');
    
    // Find the variant ID
    var $selectElement = $wishlistItem.closest('form').find('select[name="id"]');
    var variantId = null;

    // If the form and select element are found, get the selected variant ID
    if ($selectElement.length > 0) {
      var $selectedOption = $selectElement.find('option:selected');
      variantId = $selectedOption.attr('data-variant-id');
    }

    // Fallback: If no form or select element, check for variant ID in the button's data attribute
    if (!variantId) {
      variantId = $wishlistItem.attr('data-variant-id');
    }

    // If no variant ID is found, exit
    if (!variantId) {
      console.error('Variant ID not found for product handle:', productHandle);
      return;
    }

    // Find the wishlist item with the matching product handle and variant ID
    var wishlistItem = wishlist.findIndex(function (item) {
      return item.productHandle === productHandle && item.variantId === variantId;
    });

    // If the product and variant are found in the wishlist, add the 'is-active' class
    if (wishlistItem >= 0) {
      $wishlistItem.addClass('is-active');
    } else {
      $wishlistItem.removeClass('is-active'); // Remove the class if the variant is not in the wishlist
    }
  });
});


      // Remove from Wishlist Button Click Handler
  $(document).on('click', '.remove-from-wishlist', function() {
    var $wishlistItem = $(this).closest('.wishlist-tile-container');
    var productId = $wishlistItem.data('product-handle');
    var variantId = $wishlistItem.data('variant-id');
    
    // Remove item from the wishlist in localStorage
    wishlist = wishlist.filter(function(item) {
      return !(item.productHandle == productId && item.variantId == variantId);
    });
    localStorage.setItem('user_wishlist', JSON.stringify(wishlist));

    // Animate out, then remove from the DOM (transition defined in Wishlist.css)
    $wishlistItem.addClass('is-removing');
    setTimeout(function () {
      $wishlistItem.remove();
      if (wishlist.length === 0) {
        document.querySelector('.wishlist-grid--empty-list').classList.add("is_visible");
      }
    }, 220);
  });

  $(document).on("click", ".CustomaddtoCartbuttonJS", function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.addClass('btn--loading');
    var ID = $this.attr('data-add-to-cart-id'); 
    
    // Retrieve the name value from the wishlist item
    var $wishlistItem = $this.closest('.wishlist-tile-container');
    var nameValue = $wishlistItem.find('.custom-name').text().replace('Name: ', '');

    var properties = {};
    if (nameValue) {
      properties['Name'] = nameValue;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: properties
      },
      dataType: 'json',
      success: function(data) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
        $this.removeClass('btn--loading');
        
        // Remove item from the wishlist after moving to cart
        var productId = $wishlistItem.data('product-handle');
        var variantId = $wishlistItem.data('variant-id');
        
        wishlist = wishlist.filter(function(item) {
          return !(item.productHandle == productId && item.variantId == variantId);
        });
        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));

        $wishlistItem.addClass('is-removing');
        setTimeout(function () {
          $wishlistItem.remove();
          if (wishlist.length === 0) {
            document.querySelector('.wishlist-grid--empty-list').classList.add("is_visible");
          }
        }, 220);
      },
      error: function() {
        $this.removeClass('btn--loading');
        alert('Error adding product to the cart. Please try again.');
      }
    });
});

  
  
  /*
   * Display number of items in the wishlist
   * Must set the $wishlistItemCount variable
   */
  var updateWishlistItemCount = function () {
    if (wishlist) {
      $wishlistItemCount.text(wishlist.length);
    }
    if (wishlist.length > 0)
    {
      $('.swym-wishlist.site-nav__link').addClass('active');
    } else {
      $('.swym-wishlist.site-nav__link').removeClass('active');
    }
  };

  var bindUIActions = function () {
    $(document).off("click", ".wishlist-btn").on("click", ".wishlist-btn", function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
      
    });
  };

  Wishlist.init = function () {
    bindUIActions();
    activateItemsInWishlist();
    loadWishlist();
    updateWishlistItemCount();
  };

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
